import {memo,useMemo} from 'react';
const Footer = (data:any) =>{
    return(
        <div dangerouslySetInnerHTML={{__html: data.footer}} />
    )
}
export default memo(Footer);